import React, { useMemo } from "react";
import {
	arrayOf,
	bool,
	number,
	object,
	oneOf,
	string,
	elementType,
} from "prop-types";
import LandingSimpleSection from "@insightfulscience/atomic-react/LandingElement/SimpleSection";
import { Row } from "@insightfulscience/atomic-react/Grid";
import Link from "@insightfulscience/atomic-react/Link";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import colToRows from "../../utils/colToRows";
import { renderItem } from "./renderItem";

const SectionItems = ({
	TagLink = Link,
	TagDescription = Paragraph,
	type,
	title,
	colCount = 4,
	hasDescription = false,
	setID,
	plasmidID,
	items,
}) => {
	const itemsSorted = useMemo(() => {
		const isSet = type === "set";
		return isSet
			? items.sort((a, b) => {
					const itemA = a.plasmidSetName.toLowerCase();
					const itemB = b.plasmidSetName.toLowerCase();
			return itemA < itemB ? -1 : itemA > itemB ? 1 : 0; // eslint-disable-line
				})
			: items.sort((a, b) => {
					const itemA = a.customMapLabel.toLowerCase();
					const itemB = b.customMapLabel.toLowerCase();
			return itemA < itemB ? -1 : itemA > itemB ? 1 : 0; // eslint-disable-line
				});
	}, [items, type]);

	const rows = useMemo(
		() => colToRows(colCount, itemsSorted ?? []), //
		[colCount, itemsSorted],
	);

	const itemProps = useMemo(
		() => ({
			setID,
			plasmidID,
			TagLink,
			TagDescription,
			hasDescription,
			isSet: type === "set",
			colWidth: Math.round(12 / colCount),
		}),
		[setID, plasmidID, TagLink, TagDescription, hasDescription, colCount],
	);

	return (
		<LandingSimpleSection isBorderNone>
			<LandingSimpleSection.TitleV2 spacing={{ mb: 10 }}>
				{title}
			</LandingSimpleSection.TitleV2>
			<LandingSimpleSection.Body>
				{rows.map((row, rowIndex) => (
					<Row mx key={`${title}_${rowIndex}`}>
						{row.map(renderItem(itemProps))}
					</Row>
				))}
			</LandingSimpleSection.Body>
		</LandingSimpleSection>
	);
};

SectionItems.propTypes = {
	TagLink: elementType,
	TagDescription: elementType,
	title: string.isRequired,
	type: oneOf(["set", "sequence"]).isRequired,
	setID: string,
	plasmidID: string,
	hasDescription: bool,
	colCount: number,
	items: arrayOf(object),
};

export default SectionItems;
